import { defineStore } from 'pinia';

export const useSetupStore = defineStore({
  id: 'setup',
  state: () => ({
    isLoading: false,
    accountTypes: [],
    newAccount: localStorage.getItem('_pup_new_account') ? JSON.parse(localStorage.getItem('_pup_new_account')) : null,
    companyName: localStorage.getItem('_pup_new_account_company_name') ? JSON.parse(localStorage.getItem('_pup_new_account_company_name')) : null
  }),
  getters: {
    getNewAccount() {
      return this.newAccount;
    }
  },
  actions: {
    setNewAccount(account) {
      this.newAccount = account;
      localStorage.setItem('_pup_new_account', JSON.stringify(account));
    },

    setAccountTypes(accountTypes) {
      // only show account level access roles
      const visibleAccounts = ['Admin', 'Editor'];
      this.accountTypes = accountTypes.filter((type) => {
        return visibleAccounts.includes(type);
      });
    },

    clearSetup() {
      this.newAccount = null;
      this.newProject = null;
      this.companyName = null;
      localStorage.removeItem('_pup_new_account');
      localStorage.removeItem('_pup_new_account_company_name');
    }
  }
});
